import { Search } from 'lucide-react';
import { Input } from 'app/javascript/components/ui/input';

interface AdminSearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  resultCount?: number;
}

// Search box for the admin listings. The caller debounces the value before it
// reaches the query — this component only owns the input.
export default function AdminSearchField({
  value,
  onChange,
  placeholder,
  resultCount,
}: AdminSearchFieldProps) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div className="relative w-full sm:w-80">
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          type="search"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder={placeholder}
          aria-label={placeholder}
          className="pl-9"
        />
      </div>
      {resultCount !== undefined && (
        <p className="text-xs text-muted-foreground">
          {resultCount.toLocaleString('pt-BR')} {resultCount === 1 ? 'resultado' : 'resultados'}
        </p>
      )}
    </div>
  );
}
